import React from 'react';
import { mediaUrl } from '../utils/media';
import { DONATE_URL } from '../utils/donate';

const DonateSection: React.FC = () => {
  return (
    <div
      id="donate"
      className="container-fluid donate my-5 py-5"
      style={{ backgroundImage: `url(${mediaUrl('carousel-2.jpg')})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className="container py-5">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6" data-aos="fade" data-aos-delay="100">
            <div className="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3">
              Donate Now
            </div>
            <h1 className="display-6 text-white mb-5">Thanks For The Results Achieved With You</h1>
            <p className="text-white-50 mb-0">
              Your generous contributions enable us to continue our mission of helping people in need around the world. Every donation, no matter how small, makes a significant impact on the lives of those we serve.
            </p>
          </div>
          <div className="col-lg-6" data-aos="fade" data-aos-delay="500">
            <div className="h-100 bg-white p-5">
              <h2 className="mb-4">Support Our Mission</h2>
              <p className="mb-4">
                Your donation helps us continue our work in education, healthcare, and community support. You will be redirected to our secure Cashfree payment page.
              </p>
              <a
                className="btn btn-primary py-3 px-4"
                href={DONATE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Donate Now
                <div className="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2">
                  <i className="fa fa-arrow-right"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonateSection;
